import { FC } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { Button } from 'rizzui';
import fullLogo from '../../../assets/logo_completo.png';
import { menuRoutes } from '../../../router/menu';

const AgreementNotFound: FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
            <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
                <img src={fullLogo} className="h-12 mx-auto mb-6" alt="Logo de Attiva" />

                <div className="mb-6">
                    <FaExclamationTriangle className="text-orange-500 text-6xl mx-auto mb-4" />
                    <h1 className="text-2xl font-bold text-gray-900 mb-4">
                        Convenio no encontrado
                    </h1>
                    <p className="text-gray-600">
                        El enlace del convenio no es válido o ha expirado.
                        Por favor, solicite un nuevo enlace de firma.
                    </p>
                </div>

                <Button
                    onClick={() => navigate(menuRoutes.auth.login)}
                    className="w-full"
                    size="lg"
                >
                    Login
                </Button>

                <div className="mt-6 pt-6 border-t border-gray-200">
                    <p className="text-sm text-gray-500">
                        Si el problema persiste, contacte con el administrador del sistema.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AgreementNotFound;